module.exports = __webpack_public_path__ + "img/nl.ebcd669e.svg";